export default class AuditSubsectionRoutes {
  static ALL_CATEGORIZED = "all-categorized";

  static NO_PAYEE = "no-payee";

  static NO_CLASS = "no-class";

  static NO_LOCATION = "no-location";

  static NO_PROJECT = "no-project";

  static NO_ATTACHMENT = "no-attachment";

  static AMOUNT_DEVIATION = "amount-deviation";

  static DUPLICATES = "duplicates";

  static SIMILAR_PAYEE = "similar-payee";

  static POSTED_TO_PARENT = "posted-to-parent";

  static UNUSUAL_CATEGORY = "unusual-category";

  static UNUSUAL_AMOUNT = "unusual-amount";

  static UNUSUAL_TAX = "unusual-tax";
}
